<template>
  <div
    id="grafico-funnels-chat"
    class="card"
  >
    <div class="funnels">
      <vue-funnel-graph
        v-if="hasValues"
        :width="width"
        :height="height"
        :labels="labels"
        :values="values"
        :colors="colors"
        :sub-labels="subLabels"
        :direction="direction"
        :gradient-direction="gradientDirection"
        :animated="false"
        :display-percentage="true"
      />
      <div
        v-else
        class="funnel-empty-state"
      >
        <span>Sem dados para exibir no período selecionado</span>
      </div>
    </div>
  </div>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js'

export default {
  components: {
    VueFunnelGraph,
  },
  props: {
    ObjsFunnelGeral: {
      type: [Object, Array],
      default: () => [],
    },
    funnelLabels: {
      type: Array,
      default: () => ['Visualização', 'Iniciado', 'Finalizado', 'Engajamento'],
    },
  },
  data() {
    return {
      labels: ['Visualização', 'Iniciado', 'Finalizado', 'Engajamento'],
      subLabels: [],
      values: [0, 0, 0, 0],
      colors: ['#E86A10', '#F5B935'],
      direction: 'horizontal',
      gradientDirection: 'horizontal',
      height: 420,
      width: 1200,
      dataSetNum: 1,
    }
  },
  computed: {
    hasValues() {
      return Array.isArray(this.values)
        && this.values.length > 0
        && this.values.some(v => Number(v) > 0)
    },
  },
  watch: {
    ObjsFunnelGeral(newVal) {
      this.useDataSet(newVal)
    },
    funnelLabels(newVal) {
      this.labels = newVal && newVal.length ? newVal : ['Visualização', 'Iniciado', 'Finalizado', 'Engajamento']
    },
  },
  mounted() {
    this.useDataSet(this.ObjsFunnelGeral)
  },
  methods: {
    useDataSet(raw) {
      const arr = Array.isArray(raw) ? raw : []
      const hasData = arr.some(v => Number(v) > 0)
      this.labels = this.funnelLabels && this.funnelLabels.length
        ? this.funnelLabels
        : ['Visualização', 'Iniciado', 'Finalizado', 'Engajamento']
      this.subLabels = []
      this.values = hasData ? arr : [0, 0, 0, 0]
      this.colors = ['#E86A10', '#F5B935']
    },
  },
}
</script>

<style scoped>
.card {
  background-color: #0D1B2E;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
  border: none;
}

#grafico-funnels-chat {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.funnels {
  width: 100%;
  height: 500px;
  margin-top: 8px;
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.funnel-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.85rem;
}
</style>
